/** LiveHelp100 在线客服（与首页顶栏 Support / 悬浮客服按钮一致） */
export const LIVEHELP100_URL =
  "https://j5wxcf.7mmon3ss.com/chatwindow.aspx?siteId=65001365&planId=e146e265-fd7b-4e13-a3d3-76908e2394b3";

export function openLiveHelpCustomerService() {
  if (typeof window === "undefined") return;
  window.open(LIVEHELP100_URL, "_blank", "width=800,height=600,scrollbars=yes,resizable=yes");
}
